import React from "react";
import { ICommonIconProps } from "../interface";

const TwitterIcon = ({ ...props }: ICommonIconProps) => {
  return (
    <svg
      width={props?.IconWidth || "30"}
      height={props?.IconHeight || "30"}
      viewBox="0 0 30 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_29_44)">
        <path
          d="M23.6145 0H28.1928L18.1928 11.46L30 27H20.7229L13.494 17.58L5.18072 27H0.60241L11.3253 14.76L0 0H9.51807L16.0843 8.64L23.6145 0ZM21.988 24.24H24.5181L8.13253 2.58H5.36145L21.988 24.24Z"
          fill={props?.IconColor || "currentColor"}
        />
      </g>
      <defs>
        <clipPath id="clip0_29_44">
          <rect
            width="30"
            height="27"
            fill={props?.IconColor || "currentColor"}
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TwitterIcon;
